/** `?` for a segment that contains a digit, which marks an id; any other segment as it is. */
export function maskIdSegment(segment: string): string {
  return /\d/.test(segment) ? '?' : segment;
}
